<template>
  <v-container fluid fill-height class="files-wrapper">
    <v-layout v-if="clientId && parentId"
              row wrap align-center class="files-dropzone"
              :class="{'files-dropzone--dragover': fileDragInProgress}"
              @dragleave="onFileDragLeave"
              @dragover="onFileDragOver"
              @drop="onFileDrop">
      <v-flex class="text-xs-center" style="pointer-events: none;">
        <v-icon v-if="fileDragInProgress" :size="128" color="grey lighten-2">cloud_upload</v-icon>
      </v-flex>
    </v-layout>
    <v-layout wrap class="pos-rel pb-4"
      @dragleave="onFileDragLeave"
      @dragover="onFileDragOver"
    >
      <v-flex xs12>
        <FilesList />
      </v-flex>
      <div class="files_loader">
        <div class="text-xs-center" v-if="this.busy">
          <v-progress-circular
            :size="24"
            :width="3"
            indeterminate
            color="primary"
          ></v-progress-circular>
        </div>
      </div>
    </v-layout>
    <FilesUpload v-on:upload-finished="reloadFilesList"/>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import FilesList from '../components/Files/FilesList.vue';
import FilesUpload from '../components/Files/FilesUpload.vue';

export default {
  name: 'files',
  components: {
    FilesList,
    FilesUpload,
  },
  data: () => ({
    busy: false,
  }),
  computed: {
    ...mapGetters('files', [
      'filesList',
      'totalPages',
      'query',
      'currentPage',
      'fileDragInProgress',
    ]),
    clientId() {
      return this.$route.params.clientId;
    },
    parentId() {
      return this.$route.params.id;
    },
    singleParams() {
      const { params } = this.$route;
      return {
        parent_item_id: params.id,
        client_id: params.clientId,
      };
    },
    canGetPage() {
      const isLastPage = this.totalPages === this.currentPage;
      return !this.busy && this.filesList && this.filesList.length !== 0 && !isLastPage;
    },
  },
  methods: {
    ...mapActions('files', [
      'getFilesList',
      'setQuery',
      'clearSelectedFiles',
      'getFilesPage',
      'setCurrentPage',
      'setFileDragActivity',
    ]),
    getList() {
      const { query } = this.$route;
      this.setQuery(query);
      this.getFilesList(this.singleParams);
    },
    async getPage() {
      if (this.canGetPage) {
        this.busy = true;
        try {
          const nextPage = this.currentPage + 1;
          this.setCurrentPage(nextPage);
          await this.getFilesPage(this.singleParams);
          this.busy = false;
        } catch (e) {
          if (e) this.busy = false;
        }
      }
    },
    infinityScroll() {
      window.onscroll = () => {
        if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight) {
          this.getPage();
        }
      };
    },
    onFileDragOver(event) {
      this.setFileDragActivity(true);
      if (event.dataTransfer.types.includes('Files')) {
        event.dataTransfer.dropEffect = 'copy';
      } else {
        event.dataTransfer.dropEffect = 'none';
      }
      event.preventDefault();
    },
    onFileDragLeave() {
      this.setFileDragActivity(false);
    },
    onFileDrop(event) {
      this.setFileDragActivity(false);
      this.$eventBus.$emit('Files/FilesUpload/selectFiles', { files: event.dataTransfer.files });
      event.preventDefault();
      return false;
    },
    reloadFilesList() {
      this.getList();
    },
  },
  beforeDestroy() {
    this.setQuery(null);
  },
  mounted() {
    this.getList();
    this.infinityScroll();
  },
  watch: {
    $route() {
      this.getList();
      this.clearSelectedFiles();
    },
  },
};
</script>

<style scoped>
  .files-wrapper{
    position: relative;
  }
  .files-dropzone {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
  }

  .files-dropzone--dragover {
    z-index: 2;
    background-color: #fff;
    opacity: 0.8;
  }
</style>
